// extracted by mini-css-extract-plugin
export default {"priceLine":"pVYu2h","integer":"HYiCyc","fullPrice":"L72jD7"};